module.exports = __webpack_public_path__ + "img/inverter.8e12b759.png";